/* OFF-GRID: Fraktrad under ATC (snippets/og-shipping-line.liquid). Enligt handoffen.
   Impact skickar variant:change (event.detail.variant) från produktformuläret när kunden byter variant.
   Raden slås upp vid varje byte: byter kunden produkt (combined listings) renderar Impact om hela
   produktinfon, och då är raden redan rätt från servern. */
(() => {
  if (window.ogShippingLine) return;
  window.ogShippingLine = true;

  const update = (row, variantId) => {
    const states = JSON.parse(
      row.querySelector('[data-og-ship-states]')?.textContent || '{}'
    );
    const status = row.querySelector('.og-ship__status');
    const state = variantId ? (states[variantId] || 'in') : 'out';
    row.hidden = state === 'out';
    row.classList.toggle('og-ship--in', state === 'in');
    row.classList.toggle('og-ship--low', state === 'low');
    status.textContent = state === 'low'
      ? status.dataset.textLow
      : status.dataset.textIn;
  };

  document.addEventListener('variant:change', (event) => {
    const row = event.target.closest?.('.product-info')?.querySelector('[data-og-ship]');
    if (row) update(row, event.detail?.variant?.id);
  });
})();
